var map = {
	"./detail/index.json": 35616,
	"./economic-indicators-ghg/index.json": 38369,
	"./emission-factors/index.json": 66843,
	"./projects/index.json": 39071
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 64295;
module.exports = webpackAsyncContext;